var React = require('react');

function Conch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M21.403,32.333C15.821,30.567,13,28.5,13,20\n\tc0-7.875,0.083-8.917-2.417-11.417L9,7c1.706,1.706,3.5,2,10.167,2C26.452,9,31,11.866,31,22c0,10,0,13.367,0,13.367\n\tS22.734,32.754,21.403,32.333z M7.675,5.675L5,3c1.25,1.25,2.355,3.702,1.938,7.938C6.624,14.115,5,17.017,5,20.545\n\tC5,26.206,9.227,30,16.422,30 M30.975,20.734l-10.201,11.4 M25.903,33.756L31,28.059"}));
}

Conch.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Conch;

Conch.default = Conch;
